import React, {useRef} from "react";
import {HIDE, useSearchResultDetailsDispatch, useSearchResultDetailsState,} from "./SearchResultDetailsContext";
import {SearchResultDetailsModal} from "./SearchResultDetailsModal";
import {DocumentProvider} from "../documents/documentContext";
import {ObjectView} from "../objectview/ObjectView";
import {ObjectConversionProvider} from "../objectview/ObjectConversionContext";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

/**
 * Entry point for the object-view modal.
 * Responsive layout (desktop vs mobile) is handled entirely inside ObjectView.
 */
const SearchResultDetails = () => {
    const {selectedId} = useSearchResultDetailsState();
    const searchResultDetailsDispatch = useSearchResultDetailsDispatch();
    const modalRef = useRef(null);
    const searchResultDetailsModalRef = useRef(null);

    const onHide = () => {
        searchResultDetailsDispatch({type: HIDE});
    };

    const open = selectedId != null;

    return (
        <Modal
            sx={{display: "flex", alignItems: "center", justifyContent: "center"}}
            open={open}
            onClose={onHide}
            closeAfterTransition
            ref={modalRef}
        >
            {/* ObjectView manages its own full-screen Dialog with responsive margins */}
            <Box sx={{outline: "none", width: "100%", height: "100%"}}>
                <DocumentProvider>
                    <SearchResultDetailsModal ref={searchResultDetailsModalRef}>
                        <ObjectConversionProvider>
                            <ObjectView open={open}/>
                        </ObjectConversionProvider>
                    </SearchResultDetailsModal>
                </DocumentProvider>
            </Box>
        </Modal>
    );
};

export default SearchResultDetails;
